var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFouchainLogoDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 50,
    viewBox: "0 0 126 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3794 21.0646L23.7571 22.0749V15.2667L6.86401 39.4114C7.40161 39.8668 7.96394 40.2938 8.5493 40.6902L22.3794 21.0646Z",
    fill: "url(#paint0_linear_218_613)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.757 15.1758L17.6473 17.5948L19.0007 18.5874L5.34033 37.9737C5.82178 38.4794 6.33048 38.9592 6.86347 39.4114L23.7566 15.2667V15.1758H23.757Z",
    fill: "url(#paint1_linear_218_613)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4132 16.9214L7.3035 19.3165L8.63137 20.2903L1.1167 31.1068C1.38194 31.8531 1.69243 32.5776 2.04357 33.2782L13.4136 16.9574L13.4132 16.9214Z",
    fill: "url(#paint2_linear_218_613)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0067 22.7658L13.4125 23.7971V16.957L2.04248 33.2778C2.40242 33.996 2.80509 34.689 3.24883 35.3519L12.0067 22.7658Z",
    fill: "url(#paint3_linear_218_613)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0993 14.4588L24.1975 31.3427V27.4362L34.7308 12.4903C35.2265 13.1146 35.684 13.7746 36.0993 14.4588Z",
    fill: "url(#paint4_linear_218_613)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7307 12.4899L24.1975 27.4358L20.7795 28.9229L33.418 10.9952C33.8789 11.4704 34.3188 11.9694 34.7307 12.4899Z",
    fill: "url(#paint5_linear_218_613)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0952 31.5233L18.317 32.4192L11.3701 42.2749C11.9722 42.5494 12.5924 42.7899 13.2259 43.0027L23.1793 28.8789L17.0952 31.5233Z",
    fill: "url(#paint6_linear_218_613)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6929 34.8952L23.2047 36.0039V28.868L23.1792 28.8793L13.2258 43.0032C13.9775 43.2558 14.7485 43.467 15.5384 43.6262L21.6929 34.8952Z",
    fill: "url(#paint7_linear_218_613)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3972 6.78996C23.8937 6.78996 27.9979 8.4585 31.1343 11.2052L32.0385 9.92254C28.6407 6.99528 24.2238 5.21948 19.3976 5.21948C8.70174 5.21948 0 13.9212 0 24.6171C0 26.1096 0.175149 27.5611 0.495697 28.9577L1.75569 27.1701C1.63585 26.3359 1.57089 25.484 1.57089 24.6167C1.57006 14.7714 9.55151 6.78996 19.3972 6.78996Z",
    fill: "url(#paint8_linear_218_613)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9261 16.3189L35.8752 17.8097C36.743 19.9073 37.224 22.2056 37.224 24.6171C37.224 34.4628 29.2426 42.4442 19.3969 42.4442C19.104 42.4442 18.8132 42.4362 18.5241 42.422L17.469 43.9183C18.1034 43.9812 18.7466 44.0147 19.3969 44.0147C30.0927 44.0147 38.7945 35.3129 38.7945 24.6171C38.7949 21.6492 38.1228 18.8363 36.9261 16.3189Z",
    fill: "url(#paint9_linear_218_613)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M3.62301 21.7066C4.99613 14.2472 11.5471 8.57833 19.3969 8.57833C23.5041 8.57833 27.2539 10.1316 30.0945 12.6797L31.134 11.2052C27.9981 8.45851 23.8934 6.78996 19.3969 6.78996C9.55127 6.78996 1.56982 14.7714 1.56982 24.6171C1.56982 25.4845 1.63519 26.3363 1.75461 27.1706L3.3649 24.8861C3.33682 23.7003 3.44912 22.6506 3.62301 21.7066Z",
    fill: "url(#paint10_linear_218_613)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2236 24.6171C37.2236 22.2056 36.7422 19.9077 35.8748 17.8097L34.6228 19.5859C35.1474 21.1694 35.4357 22.8597 35.4357 24.6171C35.4357 33.3339 28.4448 40.4434 19.7757 40.6462L18.5237 42.422C18.8132 42.4358 19.104 42.4442 19.3965 42.4442C29.2422 42.4438 37.2236 34.4623 37.2236 24.6171Z",
    fill: "url(#paint11_linear_218_613)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.656 7.74099V14.9569H60.6679C61.709 14.9569 62.4045 14.7999 62.7546 14.4857C63.2213 14.0729 63.4815 13.3459 63.5354 12.3048H64.0335V18.6591H63.5354C63.4097 17.7706 63.2841 17.2007 63.1584 16.9494C62.9969 16.6353 62.7321 16.3884 62.3641 16.2089C61.9962 16.0294 61.4307 15.9397 60.6679 15.9397H56.656V21.9575C56.656 22.7652 56.6919 23.2588 56.7637 23.4383C56.8355 23.6089 56.9612 23.748 57.1407 23.8557C57.3202 23.9544 57.6612 24.0038 58.1638 24.0038H61.2602C62.2923 24.0038 63.0418 23.932 63.5085 23.7884C63.9752 23.6448 64.4239 23.3621 64.8547 22.9402C65.4112 22.3838 65.9811 21.5446 66.5645 20.4227H67.103L65.5278 25H51.4595V24.5019H52.1057C52.5365 24.5019 52.9448 24.3987 53.3308 24.1922C53.618 24.0486 53.8109 23.8332 53.9097 23.546C54.0174 23.2588 54.0712 22.671 54.0712 21.7824V9.92193C54.0712 8.76415 53.9545 8.05063 53.7212 7.78138C53.3981 7.42238 52.8596 7.24288 52.1057 7.24288H51.4595V6.74476H65.5278L65.7298 10.7431H65.2047C65.0163 9.78282 64.8054 9.12315 64.572 8.76415C64.3476 8.40515 64.0111 8.13141 63.5623 7.94293C63.2033 7.80831 62.5706 7.74099 61.6641 7.74099H56.656ZM79.0308 25L71.9764 9.63922V21.8363C71.9764 22.9582 72.0976 23.6582 72.3399 23.9365C72.672 24.3134 73.197 24.5019 73.915 24.5019H74.5612V25H68.2069V24.5019H68.8531C69.625 24.5019 70.1724 24.2685 70.4955 23.8018C70.693 23.5146 70.7917 22.8595 70.7917 21.8363V9.90847C70.7917 9.10071 70.702 8.51734 70.5225 8.15833C70.3968 7.89806 70.1635 7.68266 69.8224 7.51213C69.4903 7.33263 68.9518 7.24288 68.2069 7.24288V6.74476H73.3765L80.0001 21.0285L86.516 6.74476H91.6856V7.24288H91.0529C90.272 7.24288 89.7201 7.47623 89.397 7.94293C89.1995 8.23013 89.1008 8.88531 89.1008 9.90847V21.8363C89.1008 22.9582 89.2264 23.6582 89.4777 23.9365C89.8098 24.3134 90.3349 24.5019 91.0529 24.5019H91.6856V25H83.9312V24.5019H84.5774C85.3582 24.5019 85.9057 24.2685 86.2198 23.8018C86.4173 23.5146 86.516 22.8595 86.516 21.8363V9.63922L79.4751 25H79.0308ZM110.91 25H106.037L99.8574 16.4647C99.3997 16.4827 99.0272 16.4917 98.74 16.4917C98.6233 16.4917 98.4977 16.4917 98.363 16.4917C98.2284 16.4827 98.0893 16.4737 97.9457 16.4647V21.769C97.9457 22.9178 98.0714 23.6313 98.3227 23.9095C98.6637 24.3044 99.1753 24.5019 99.8574 24.5019H100.571V25H92.7492V24.5019H93.4357C94.2076 24.5019 94.7596 24.2506 95.0916 23.748C95.2801 23.4698 95.3744 22.8101 95.3744 21.769V9.97578C95.3744 8.82697 95.2487 8.11346 94.9974 7.83523C94.6474 7.44033 94.1268 7.24288 93.4357 7.24288H92.7492V6.74476H99.3997C101.338 6.74476 102.765 6.88837 103.681 7.17557C104.605 7.45379 105.386 7.97435 106.023 8.73722C106.669 9.49113 106.993 10.3931 106.993 11.4432C106.993 12.5651 106.625 13.5389 105.889 14.3646C105.162 15.1903 104.031 15.7737 102.496 16.1147L106.266 21.3516C107.127 22.5543 107.868 23.3531 108.487 23.748C109.106 24.1429 109.914 24.3942 110.91 24.5019V25ZM97.9457 15.6166C98.1162 15.6166 98.2643 15.6211 98.39 15.6301C98.5156 15.6301 98.6188 15.6301 98.6996 15.6301C100.441 15.6301 101.751 15.2531 102.631 14.4992C103.519 13.7453 103.963 12.785 103.963 11.6182C103.963 10.4784 103.604 9.55395 102.886 8.84492C102.177 8.12692 101.235 7.76792 100.059 7.76792C99.5388 7.76792 98.8342 7.85318 97.9457 8.02371V15.6166ZM124.952 6.74476L125.154 11.0259H124.642C124.543 10.272 124.409 9.73345 124.238 9.41035C123.96 8.8898 123.587 8.50836 123.121 8.26603C122.663 8.01473 122.057 7.88908 121.303 7.88908H118.732V21.8363C118.732 22.9582 118.853 23.6582 119.095 23.9365C119.436 24.3134 119.961 24.5019 120.671 24.5019H121.303V25H113.562V24.5019H114.208C114.98 24.5019 115.528 24.2685 115.851 23.8018C116.048 23.5146 116.147 22.8595 116.147 21.8363V7.88908H113.953C113.1 7.88908 112.494 7.95191 112.135 8.07756C111.669 8.24808 111.269 8.57567 110.937 9.06033C110.605 9.54498 110.408 10.2002 110.345 11.0259H109.833L110.049 6.74476H124.952Z",
    fill: "url(#paint12_linear_218_613)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9773 35.3085H56.102V45.2341H55.0297V35.3085H51.1544V34.3588H59.9773V35.3085ZM67.6744 38.1728C66.98 38.1932 66.3673 38.3872 65.8363 38.7549C65.3155 39.1225 64.9479 39.628 64.7334 40.2713V45.2341H63.6919V37.2538H64.6722V39.1684C64.9479 38.6068 65.3104 38.1524 65.7597 37.8052C66.2192 37.458 66.7043 37.264 67.2149 37.2231C67.317 37.2129 67.4038 37.2078 67.4753 37.2078C67.5569 37.2078 67.6233 37.2129 67.6744 37.2231V38.1728ZM72.0649 42.9365C72.0649 42.4361 72.2078 42.0073 72.4937 41.6499C72.7797 41.2822 73.1728 41.0014 73.6732 40.8074C74.1838 40.6032 74.7709 40.5011 75.4347 40.5011C75.8227 40.5011 76.2261 40.5317 76.6448 40.593C77.0634 40.6542 77.4362 40.7461 77.7629 40.8687V40.1947C77.7629 39.5207 77.5638 38.9846 77.1655 38.5864C76.7673 38.1881 76.2159 37.989 75.5113 37.989C75.0824 37.989 74.6586 38.0707 74.2399 38.2341C73.8315 38.3872 73.4026 38.617 72.9533 38.9234L72.555 38.1881C73.0758 37.8307 73.5864 37.5652 74.0867 37.3916C74.5871 37.2078 75.0977 37.1159 75.6185 37.1159C76.5988 37.1159 77.3749 37.3967 77.9467 37.9584C78.5186 38.52 78.8045 39.2961 78.8045 40.2866V43.9781C78.8045 44.1211 78.8351 44.2283 78.8964 44.2998C78.9577 44.361 79.0547 44.3968 79.1874 44.407V45.2341C79.0751 45.2443 78.9781 45.2546 78.8964 45.2648C78.8147 45.275 78.7534 45.275 78.7126 45.2648C78.4573 45.2546 78.2633 45.1729 78.1305 45.0197C77.9978 44.8665 77.9263 44.7031 77.9161 44.5295L77.9008 43.9475C77.5434 44.407 77.0787 44.7644 76.5069 45.0197C75.935 45.2648 75.353 45.3873 74.7607 45.3873C74.2501 45.3873 73.7855 45.2801 73.3668 45.0656C72.9584 44.841 72.6367 44.5448 72.4018 44.1772C72.1772 43.7994 72.0649 43.3858 72.0649 42.9365ZM77.4106 43.5492C77.523 43.4063 77.6098 43.2684 77.671 43.1356C77.7323 43.0029 77.7629 42.8855 77.7629 42.7833V41.6192C77.4157 41.4865 77.0532 41.3844 76.6754 41.3129C76.3078 41.2414 75.935 41.2057 75.5572 41.2057C74.8118 41.2057 74.2093 41.3537 73.7498 41.6499C73.2902 41.946 73.0605 42.3494 73.0605 42.8599C73.0605 43.1561 73.1371 43.4369 73.2902 43.7024C73.4434 43.9577 73.6681 44.1721 73.9642 44.3457C74.2603 44.5091 74.6075 44.5908 75.0058 44.5908C75.5062 44.5908 75.9708 44.4938 76.3997 44.2998C76.8388 44.1057 77.1758 43.8556 77.4106 43.5492ZM84.195 41.2669C84.195 40.5113 84.3482 39.822 84.6546 39.1991C84.9711 38.566 85.4051 38.0605 85.9565 37.6826C86.508 37.3048 87.136 37.1159 87.8406 37.1159C88.5043 37.1159 89.0966 37.2946 89.6174 37.652C90.1484 37.9992 90.562 38.423 90.8581 38.9234V34.0524H91.8997V43.9781C91.8997 44.1211 91.9303 44.2283 91.9916 44.2998C92.0529 44.361 92.1448 44.3968 92.2673 44.407V45.2341C92.0631 45.2648 91.9048 45.275 91.7925 45.2648C91.578 45.2546 91.3891 45.1678 91.2257 45.0044C91.0623 44.841 90.9806 44.6623 90.9806 44.4683V43.6871C90.6641 44.2079 90.2352 44.6214 89.694 44.9278C89.1528 45.2341 88.5911 45.3873 88.0091 45.3873C87.4576 45.3873 86.9471 45.275 86.4773 45.0503C86.0178 44.8257 85.6144 44.5193 85.2673 44.1313C84.9303 43.7432 84.6648 43.3041 84.4707 42.814C84.2869 42.3136 84.195 41.7979 84.195 41.2669ZM90.8581 42.4923V40.0262C90.7254 39.6586 90.5109 39.3267 90.2148 39.0306C89.9186 38.7242 89.5817 38.4843 89.2038 38.3107C88.8362 38.1269 88.4686 38.0349 88.101 38.0349C87.6721 38.0349 87.284 38.1269 86.9369 38.3107C86.5897 38.4843 86.2884 38.7242 86.0331 39.0306C85.788 39.3369 85.5991 39.6841 85.4664 40.0722C85.3336 40.4602 85.2673 40.8585 85.2673 41.2669C85.2673 41.6958 85.3387 42.1043 85.4817 42.4923C85.6349 42.8804 85.8493 43.2275 86.125 43.5339C86.4007 43.83 86.7173 44.0598 87.0747 44.2232C87.4321 44.3866 87.8202 44.4683 88.2388 44.4683C88.5043 44.4683 88.78 44.4172 89.066 44.3151C89.3519 44.213 89.6225 44.0751 89.8778 43.9015C90.1433 43.7177 90.3628 43.5033 90.5364 43.2582C90.71 43.0131 90.8173 42.7578 90.8581 42.4923ZM101.382 45.3873C100.81 45.3873 100.279 45.2801 99.7892 45.0656C99.2991 44.841 98.8753 44.5397 98.5179 44.1619C98.1605 43.7739 97.8797 43.3297 97.6754 42.8293C97.4814 42.3289 97.3844 41.7928 97.3844 41.221C97.3844 40.4755 97.5529 39.7913 97.8899 39.1684C98.2371 38.5455 98.7119 38.0503 99.3144 37.6826C99.9169 37.3048 100.601 37.1159 101.367 37.1159C102.153 37.1159 102.837 37.3048 103.419 37.6826C104.012 38.0605 104.476 38.5608 104.813 39.1838C105.15 39.7965 105.319 40.4704 105.319 41.2057C105.319 41.2873 105.319 41.369 105.319 41.4507C105.319 41.5222 105.314 41.5784 105.303 41.6192H98.4719C98.523 42.1911 98.6813 42.7017 98.9468 43.151C99.2225 43.5901 99.5748 43.9424 100.004 44.2079C100.443 44.4632 100.918 44.5908 101.428 44.5908C101.949 44.5908 102.439 44.458 102.899 44.1925C103.368 43.927 103.695 43.5798 103.879 43.151L104.783 43.396C104.619 43.7739 104.369 44.116 104.032 44.4223C103.695 44.7287 103.297 44.9686 102.837 45.1422C102.388 45.3056 101.903 45.3873 101.382 45.3873ZM98.4413 40.8687H104.338C104.298 40.2866 104.139 39.776 103.864 39.3369C103.598 38.8978 103.246 38.5557 102.807 38.3107C102.378 38.0554 101.903 37.9277 101.382 37.9277C100.861 37.9277 100.387 38.0554 99.9577 38.3107C99.5288 38.5557 99.1765 38.9029 98.9008 39.3522C98.6353 39.7913 98.4821 40.2968 98.4413 40.8687ZM114.585 38.1728C113.89 38.1932 113.277 38.3872 112.746 38.7549C112.226 39.1225 111.858 39.628 111.644 40.2713V45.2341H110.602V37.2538H111.582V39.1684C111.858 38.6068 112.221 38.1524 112.67 37.8052C113.129 37.458 113.614 37.264 114.125 37.2231C114.227 37.2129 114.314 37.2078 114.385 37.2078C114.467 37.2078 114.533 37.2129 114.585 37.2231V38.1728ZM122.268 45.3873C121.614 45.3873 121.006 45.2801 120.445 45.0656C119.883 44.8512 119.398 44.5244 118.99 44.0853L119.418 43.3501C119.868 43.7688 120.317 44.0751 120.766 44.2691C121.226 44.4529 121.711 44.5448 122.222 44.5448C122.844 44.5448 123.35 44.4223 123.738 44.1772C124.126 43.9219 124.32 43.5594 124.32 43.0897C124.32 42.7731 124.223 42.5332 124.029 42.3698C123.845 42.1962 123.575 42.0583 123.217 41.9562C122.87 41.8439 122.451 41.7264 121.961 41.6039C121.41 41.4507 120.945 41.2925 120.567 41.1291C120.2 40.9555 119.919 40.741 119.725 40.4857C119.541 40.2202 119.449 39.8781 119.449 39.4595C119.449 38.9387 119.577 38.5098 119.832 38.1728C120.098 37.8256 120.455 37.5652 120.904 37.3916C121.364 37.2078 121.874 37.1159 122.436 37.1159C123.049 37.1159 123.59 37.2129 124.06 37.4069C124.529 37.601 124.912 37.8716 125.208 38.2188L124.703 38.9234C124.417 38.5966 124.075 38.3566 123.677 38.2034C123.289 38.0401 122.855 37.9584 122.375 37.9584C122.048 37.9584 121.737 38.0043 121.44 38.0962C121.144 38.1779 120.899 38.3209 120.705 38.5251C120.521 38.7191 120.429 38.9897 120.429 39.3369C120.429 39.6229 120.501 39.8475 120.644 40.0109C120.787 40.1641 121.001 40.2968 121.287 40.4091C121.573 40.5113 121.925 40.6236 122.344 40.7461C122.947 40.9095 123.472 41.078 123.922 41.2516C124.371 41.415 124.718 41.6294 124.963 41.8949C125.208 42.1604 125.331 42.5332 125.331 43.0131C125.331 43.7586 125.05 44.3406 124.489 44.7593C123.927 45.178 123.187 45.3873 122.268 45.3873Z",
    fill: "url(#paint13_linear_218_613)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_218_613",
    x1: 6.86428,
    y1: 40.6907,
    x2: 32.491,
    y2: 23.2044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16181B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1E21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_218_613",
    x1: 5.34062,
    y1: 39.4118,
    x2: 30.7896,
    y2: 19.5529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16181B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1E21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_218_613",
    x1: 1.1167,
    y1: 25.0998,
    x2: 13.4136,
    y2: 25.0998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E5E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F8BC36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.537052,
    stopColor: "#F8EB51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783654,
    stopColor: "#E89B02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#874600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_218_613",
    x1: 2.04248,
    y1: 26.1544,
    x2: 13.4125,
    y2: 26.1544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E5E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F8BC36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.537052,
    stopColor: "#F8EB51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783654,
    stopColor: "#E89B02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#874600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_218_613",
    x1: 24.1975,
    y1: 21.9165,
    x2: 36.0993,
    y2: 21.9165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E5E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F8BC36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.537052,
    stopColor: "#F8EB51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783654,
    stopColor: "#E89B02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#874600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_218_613",
    x1: 20.7795,
    y1: 19.9591,
    x2: 34.7307,
    y2: 19.9591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E5E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F8BC36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.537052,
    stopColor: "#F8EB51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783654,
    stopColor: "#E89B02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#874600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_218_613",
    x1: 11.3701,
    y1: 35.9408,
    x2: 23.1793,
    y2: 35.9408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E5E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F8BC36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.537052,
    stopColor: "#F8EB51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783654,
    stopColor: "#E89B02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#874600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_218_613",
    x1: 13.2258,
    y1: 36.2471,
    x2: 23.2047,
    y2: 36.2471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E5E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F8BC36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.537052,
    stopColor: "#F8EB51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783654,
    stopColor: "#E89B02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#874600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_218_613",
    x1: 0,
    y1: 17.0886,
    x2: 32.0385,
    y2: 17.0886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E5E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F8BC36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.537052,
    stopColor: "#F8EB51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783654,
    stopColor: "#E89B02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#874600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_218_613",
    x1: 17.469,
    y1: 30.1668,
    x2: 38.7945,
    y2: 30.1668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E5E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F8BC36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.537052,
    stopColor: "#F8EB51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783654,
    stopColor: "#E89B02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#874600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_218_613",
    x1: 1.56982,
    y1: 16.9803,
    x2: 31.134,
    y2: 16.9803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E5E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F8BC36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.537052,
    stopColor: "#F8EB51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783654,
    stopColor: "#E89B02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#874600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_218_613",
    x1: 18.5237,
    y1: 30.127,
    x2: 37.2236,
    y2: 30.127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E5E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F8BC36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.537052,
    stopColor: "#F8EB51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783654,
    stopColor: "#E89B02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#874600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_218_613",
    x1: 50.894,
    y1: 16,
    x2: 125.949,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E5E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F8BC36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.537052,
    stopColor: "#F8EB51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783654,
    stopColor: "#E89B02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#874600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_218_613",
    x1: 50.8952,
    y1: 49.2345,
    x2: 59.5258,
    y2: 12.2791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16181B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1E21"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFouchainLogoDark);
export default __webpack_public_path__ + "static/media/fouchain-logo-dark.3cbdebcba248b2450410a1c75adbd6ba.svg";
export { ForwardRef as ReactComponent };